import { Key, LanguageCode, Song } from './types'

export function getSongTitle(song: Song, lang: LanguageCode) {
    return song.localizedTitle?.[lang] ?? song.title
}

export function formatKeytone(key: Key, lang: LanguageCode, onlyMode = false) {
    const modeMap = {
        en: {
            major: 'major',
            minor: 'minor'
        },
        sv: {
            major: 'dur',
            minor: 'moll'
        },
        no: {
            major: 'dur',
            minor: 'moll'
        }
    }

    const mode = modeMap[lang][key.mode]

    if (onlyMode) return mode

    return lang === 'en' ? `${key.tonic}-${mode}` : `${key.tonic}-${mode}`
}
